/*
 * @Author: sunxiaodong
 * @Date: 2018-12-19 13:56:38
 * @Last Modified by: mikey.zhaopeng
 * @Last Modified time: 2023-08-15 16:30:16
 */
import request from "_private/utils/request";

/**
 * @description 获取表格列
 * @author sunxiaodong
 * @export
 * @param {*} data
 * @returns */
export function FetchGetTableColumnSettings(data) {
  return request({
    url: "/base/tableColumnSetting/getTableColumnSettings",
    method: "post",
    data,
  });
}

/**
 * @description 表格列设置
 * @author sunxiaodong
 * @export
 * @param {*} data
 * @returns
 */
export function FetchSaveUserTableColumnSettings(data) {
  return request({
    url: "/base/tableColumnSetting/saveUserTableColumnSettings",
    method: "post",
    data,
  });
}

/**
 * @description 根据用户id获取组织架构，但用户id不需要传
 * @author sunxiaodong
 * @export
 * @returns
 */
export function FetchFindOrganizationTreeByOrgId() {
  return request({
    url: "/base/organization/findOrganizationTreeByOrgId",
    method: "post",
  });
}

/**
 * @description 获取角色名
 * @author huzhibo
 * @export
 * @returns
 */
export function FetchUserAllRole() {
  return request({
    url: "/base/user/getUserAllRole",
    method: "get",
  });
}

/**
 * @description 获取权限接口
 * @author sunxiaodong
 * @export
 * @returns
 */
export function FetchGetAllModule() {
  return request({
    url: "/base/role/getAllModule",
    method: "post",
  });
}

/**
 * @description 根据多个字典表类型获取多个字典列表
 * @author xiashuhao
 * @export
 * @param {*} data
 * @returns
 */
export function FetchGetDictionaryByTypeList(data) {
  return request({
    headers: { type: "json" },
    url: "/base/dictionary/getDictByDicTypeKey",
    method: "post",
    data,
  });
}
export function FetchGetDictionaryByKey(data) {
  return request({
    url: "/base/dictionary/getDictByDicTypeKey",
    method: "post",
    data,
  });
}

/**
 * @description 修改密码
 * @author sunxiaodong
 * @export
 * @param {*} data
 * @returns
 */
export function FetchModifyPassword(data) {
  return request({
    url: "/base/user/modifyUserPassword",
    method: "post",
    data,
  });
}
